import {Injectable} from '@angular/core';

export const STORAGE_KEY_TOKEN = 'auth_token';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  getToken(): string {
    return localStorage.getItem(STORAGE_KEY_TOKEN);
  }

  setToken(value: string): void {
    this.flushSession();
    localStorage.setItem(STORAGE_KEY_TOKEN, value);
  }

  flushSession(): void {
    localStorage.removeItem(STORAGE_KEY_TOKEN);
  }
}
